export default __webpack_public_path__ + "static/media/img_pindao.4d1bf422.png";